import { config } from '@abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import GET_OFFER_RECOMMENDATION from './getOfferRecommendations.graphql';
import SAVE_OFFER_DISPOSITION_MUTATION from './saveOfferDisposition.graphql';

export const useGetOfferRecommendations = (options) =>
  useCustomQuery(GET_OFFER_RECOMMENDATION, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'getOfferRecommendations',
  });

export const useSaveOfferDisposition = (options) =>
  useCustomQuery(SAVE_OFFER_DISPOSITION_MUTATION, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'saveOfferDisposition',
    requestPolicy: 'no-cache',
  });
